"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var path_exports = {};
__export(path_exports, {
  appendPath: () => appendPath,
  createPath: () => createPath,
  isPath: () => isPath,
  pathDel: () => pathDel,
  pathGet: () => pathGet,
  pathSet: () => pathSet,
  pathToString: () => pathToString,
  pathUpdate: () => pathUpdate,
  prefixPath: () => prefixPath,
  prefixPaths: () => prefixPaths,
  unsafeStringToPath: () => unsafeStringToPath
});
module.exports = __toCommonJS(path_exports);
var import_fp = require("@cartographerio/fp");
var import_guard = require("@cartographerio/guard");
var import_lodash = require("lodash");
var import_message = require("./message.js");
function isPath(p) {
  return Array.isArray(p) && p.reduce((accum, item) => accum && (typeof item === "string" || typeof item === "number"), true);
}
function pathToString(path) {
  return "/" + path.join("/");
}
function unsafeStringToPath(str) {
  return str.split(".").map((field) => {
    const index = parseInt(field, 10);
    return Number.isNaN(index) ? field : index;
  });
}
function createPath(path) {
  if (typeof path === "string" || typeof path === "number") {
    return [path];
  } else {
    return path;
  }
}
function appendPath(path, suffix) {
  if (typeof suffix === "string" || typeof suffix === "number") {
    return [...path, suffix];
  } else {
    return [...path, ...suffix];
  }
}
function prefixPath(prefix, path) {
  if (typeof prefix === "string" || typeof prefix === "number") {
    return [prefix, ...path];
  } else {
    return [...prefix, ...path];
  }
}
function prefixPaths(prefix, paths) {
  return paths.map((path) => prefixPath(prefix, path));
}
function pathGet(document, path) {
  if (path.length === 0) {
    return document;
  } else {
    const [head, ...tail] = path;
    if (typeof head === "string") {
      return (0, import_guard.hasKeyOfAnyType)(document, head) ? pathGet(document[head], tail) : void 0;
    } else {
      return Array.isArray(document) ? pathGet(document[head], tail) : void 0;
    }
  }
}
function trimArray(arr) {
  let end = arr.length - 1;
  while (end >= 0 && arr[end] === void 0) {
    end = end - 1;
  }
  if (end === arr.length - 1) {
    return arr;
  } else {
    return arr.slice(0, end + 1);
  }
}
function pathUpdate(doc, path, func) {
  if (path.length === 0) {
    return import_fp.Result.pure(func(doc));
  } else {
    const [head, ...tail] = path;
    if (typeof head === "string") {
      if (doc == null) {
        return pathUpdate(null, tail, func).map((replacement) => ({
          [head]: replacement
        }));
      } else if ((0, import_guard.hasKeyOfAnyType)(doc, head)) {
        return pathUpdate(doc[head], tail, func).flatMap((replacement) => {
          if (replacement === void 0) {
            const copy = { ...doc };
            delete copy[head];
            return import_fp.Result.pure(copy);
          } else {
            return import_fp.Result.pure({ ...doc, [head]: replacement });
          }
        });
      } else if ((0, import_guard.isObject)(doc) && !Array.isArray(doc)) {
        return pathUpdate(null, tail, func).map(
          (replacement) => replacement === void 0 ? doc : { ...doc, [head]: replacement }
        );
      } else {
        return import_fp.Result.fail((0, import_message.errorMessage)("Could not update field", path));
      }
    } else {
      if (doc == null) {
        const ans = (0, import_lodash.fill)(Array(head + 1), null);
        ans[head] = pathUpdate(null, tail, func).getOrUndefined();
        return import_fp.Result.pure(ans);
      } else if (Array.isArray(doc) && head >= 0) {
        if (head >= doc.length) {
          return pathUpdate(null, tail, func).map(
            (replacement) => replacement === void 0 ? doc : trimArray([...doc, ...(0, import_lodash.fill)(Array(head - doc.length), null), replacement])
          );
        } else {
          return pathUpdate(doc[head], tail, func).map(
            (replacement) => trimArray([...doc.slice(0, head), replacement, ...doc.slice(head + 1)])
          );
        }
      } else {
        return import_fp.Result.fail((0, import_message.errorMessage)("Could not update index", path));
      }
    }
  }
}
function pathSet(document, path, value) {
  return pathUpdate(document, path, () => value);
}
function pathDel(document, path) {
  return pathUpdate(document, path, () => void 0);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  appendPath,
  createPath,
  isPath,
  pathDel,
  pathGet,
  pathSet,
  pathToString,
  pathUpdate,
  prefixPath,
  prefixPaths,
  unsafeStringToPath
});
//# sourceMappingURL=path.js.map
